export default "__VITE_ASSET__CAIwmdbs__"